import { render, staticRenderFns } from "./gwgk.vue?vue&type=template&id=7b3a2c86&scoped=true"
import script from "./gwgk.vue?vue&type=script&lang=js"
export * from "./gwgk.vue?vue&type=script&lang=js"
import style0 from "./gwgk.vue?vue&type=style&index=0&id=7b3a2c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a2c86",
  null
  
)

export default component.exports